
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface LogoProps {
  textSize?: string;
  linkTo?: boolean;
}

const Logo: React.FC<LogoProps> = ({ textSize = "text-2xl", linkTo = true }) => {
  const LogoContent = () => (
    <span className="flex items-center font-bold">
      <span 
        className={cn(
          "text-purple-600", 
          textSize, 
          "mr-1"
        )}
      >
        OGM
      </span>
      <span 
        className={cn(
          "text-white", 
          textSize, 
          "px-1.5 py-0.5 rounded-lg", 
          "bg-purple-600"
        )}
      >
        AI
      </span>
    </span>
  );
  
  return (
    <div className="flex items-center">
      {linkTo ? (
        <Link to="/">
          <LogoContent />
        </Link>
      ) : (
        <LogoContent />
      )}
    </div>
  );
};

export default Logo;
